export default {
    Default: 'default',
    DefaultFromMenu: 'default-from-menu',
    DefaultToHomepage: 'default-to-homepage',

    HomepageSliderToWork: 'homepage-slider-to-work',
    ContextSliderToWork: 'context-slider-to-work',
    OverviewToStory: 'overview-to-story',
    RelatedStory: 'related-story',
};



// WEBPACK FOOTER //
// ./resources/assets/js/navigation/transitions.js